import { Injectable } from '@angular/core';
import { CacheObjectService } from '@app/core';
import { Observable } from 'rxjs';

import { SearchResponse } from './isearch';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private searchType = 'allpages';
  private readonly BASE_URL = `/api/audiobooks/search?q=`;

  public isBackFromItem: boolean = false;

  constructor(private readonly cache: CacheObjectService<SearchResponse>) { }

  public list(search: string = null, page: number, pageSize: number): Observable<any> {
    let url = `${this.BASE_URL + encodeURIComponent(search)}&$inlinecount=${this.searchType}&$skip=${page * pageSize}&$top=${pageSize}`;
    return this.cache.getObjectCacheOfList(url, search, page);
  }
}
